import { StockTabs } from './stockConstants';

export class StockCache {
  static viewCacheKey(tab: StockTabs) {
    return `stock-view-${tab}`;
  }

  static scaleCacheKey(tab: StockTabs) {
    return `stock-scale-${tab}`;
  }

  static checkedProductsCategories() {
    return 'checked-products-categories';
  }

  static checkedLifestylesCategories() {
    return 'checked-lifestyles-categories';
  }

  static checkedMaterialsCategories() {
    return 'checked-materials-categories';
  }
}
